<template>
  <div style="background-color: #fdfdfd">
    <Header :isHome="false"></Header>

    <div class="top-bg" style="padding-top: 4rem">
      <div class="title-box">
        <img src="../../assets/imgs/export-title-icon.png" class="title-icon" />
        <span class="title-text">Service Providers</span>
      </div>
      <div style="" class="search-box" @keydown.enter="tosearchmain(5)">
        <input
          type="text"
          style="
            border: none;
            background-color: transparent;
            color: #000;
            font-size: 1rem;
            width: 100%;
          "
          v-model="searchkeyword"
          placeholder="Search"
        />
        <img
          src="../../assets/imgs/search-dark.png"
          style="width: 1rem; height: 1rem; cursor: pointer"
          @click="tosearchmain(5)"
        />
      </div>
    </div>
    <div
      v-show="sidebox"
      style="
        position: fixed;
        right: 0;
        bottom: 0;
        height: 100vh;
        z-index: 5;
        background-color: rgba(0, 0, 0, 0.55);
        width: 100vw;
      "
      @click="sidebox = !sidebox"
    ></div>
    <div class="container" v-if="data" style="">
      <div class="row" style="margin-top: 2rem">
        <div
          class="col-3 side-box transition-normal"
          :style="{ maxWidth: sidebox || !isMobile ? '11rem' : '4.1rem' }"
        >
          <div class="side-title" v-if="!isMobile">
            <span style="flex: 1">Filter By</span>
            <img
              src="../../assets/imgs/arrow-down-black.png"
              class="transition-normal"
              style="width: 1rem; height: 0.5rem; cursor: pointer"
              :style="{ transform: filtershow ? 'rotate(180deg)' : 'none' }"
              @click="filtershow = !filtershow"
            />
          </div>
          <div class="side-title" v-else>
            <span style="flex: 1">
              <img
                :src="
                  sidebox
                    ? require('../../assets/imgs/mobile-side-icon.svg')
                    : require('../../assets/imgs/mobile-side-icon-before.svg')
                "
                style="width: 2rem; height: 2rem; cursor: pointer"
                @click="sidebox = !sidebox"
              />
            </span>
            <!-- <img src="../../assets/imgs/arrow-down-black.png" style="width: 1rem;height: 0.5rem;"> -->
          </div>
          <div
            class="side-content transition-normal"
            v-if="sidebox || !isMobile"
            :style="{
              height: filtershow ? (sidedata.length + 1) * 2.4 + 'rem' : '0rem',
            }"
            style="overflow: scroll"
          >
            <!-- <div style="display: flex;margin-bottom: 1rem;align-items: center;margin:1rem 1rem 0.5rem">
							<div style="width: 1rem;height: 1rem;border: 1px solid #666;margin-right: 1rem;"
									:style="{backgroundColor: isall?'#00C2A0':'transparent'}"@click="checkall()"></div>All supplier
						</div> -->
            <div
              style="
                display: flex;
                margin-bottom: 1rem;
                align-items: center;
                margin: 0.5rem 1rem;
              "
              v-for="(item, index) in sidedata"
              :key="index"
              @click="checksidedata(item)"
            >
              <div
                style="
                  width: 1rem;
                  height: 1rem;
                  border: 1px solid #666;
                  margin-right: 1rem;
                "
                :style="{
                  backgroundColor: cidslist.includes(item)
                    ? '#00C2A0'
                    : 'transparent',
                }"
              ></div>
              {{ item.name }}
            </div>
            <div
              style="
                display: flex;
                margin-bottom: 1rem;
                align-items: center;
                margin: 0.5rem 1rem;
              "
            >
              <div
                style="
                  width: 1rem;
                  height: 1rem;
                  border: 1px solid #666;
                  margin-right: 1rem;
                "
                :style="{
                  backgroundColor: website ? '#00C2A0' : 'transparent',
                }"
                @click="changewebsite"
              ></div>
              Website
            </div>
          </div>
        </div>
        <div class="col-9 main-box">
          <!-- <div class="r-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">ISO9000</span>
					</div> -->
          <div style="display: flex; flex-wrap: wrap; margin-bottom: 1rem">
            <div
              v-for="(item, cidsindex) in cidslist"
              :key="cidsindex"
              style="
                margin-right: 0.5rem;
                margin-bottom: 0.5rem;
                padding: 0.4rem 0.7rem;
              "
              class="btn-normal"
            >
              <span style="margin-right: 0.5rem" v-text="item.name"></span
              ><img
                src="../../assets/imgs/close-tag.png"
                style="width: q 1.2rem; height: 1.2rem; cursor: pointer"
                @click="closetag(item)"
              />
            </div>
          </div>

          <div
            class="hover-up transition-normal fadeIn animated supplier-box"
            style="
              background-color: #fff;
              padding: 1rem;
              display: flex;
              margin-bottom: 2rem;
              border-radius: 1rem;
            "
            v-for="(item, index2) in data.items"
            :key="index2"
          >
            <div
              :style="{ backgroundImage: 'url(' + item.coverImage + ')' }"
              @click="tosupplierdetail(item)"
              style="cursor: pointer"
              class="main-img"
            ></div>
            <div
              style="
                display: flex;
                flex-direction: column;
                width: 100%;
                position: relative;
              "
            >
              <div
                style="cursor: pointer"
                class="main-title"
                @click="tosupplierdetail(item)"
                v-text="item.providerName"
              ></div>
              <div
                style="display: flex; flex-wrap: wrap; cursor: pointer"
                @click="tosupplierdetail(item)"
              >
                <div
                  v-for="(c, index3) in item.certifications"
                  :key="index3"
                  style="
                    padding: 0rem 0.5rem;
                    border: 1px solid #d8d8d8;
                    border-radius: 2rem;
                    font-size: 0.5rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 0.5rem;
                    margin-bottom: 0.5rem;
                  "
                  v-text="c.name"
                ></div>
              </div>
              <div
                style="font-size: 0.7rem; color: #666; cursor: pointer"
                @click="tosupplierdetail(item)"
                class="supplier-desc"
                v-text="item.providerDescription"
              ></div>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  margin-top: 1rem;
                "
                v-if="!isMobile"
              >
                <div
                  style="
                    color: #333;
                    font-size: 0.8rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 3rem;
                    padding: 0.4rem 0.7rem;
                    font-weight: bold;
                    width: 6rem;
                    cursor: pointer;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                  "
                  :class="{
                    'btn-cyan': !item.follow,
                    'btn-lightgreen': item.follow,
                  }"
                  @click="changefollow(item)"
                  v-text="item.follow ? 'UnFollow' : 'Follow'"
                ></div>
              </div>
            </div>
          </div>

          <pagination
            :page="page"
            :page-size="perPage"
            :total="data.total || 0"
            :on-page-change="onPage"
            :pageSizeList="[]"
            class="pagi page-content"
          />
          <Footer style="margin-top: 3rem" v-if="isMobile"></Footer>
        </div>
      </div>
    </div>
    <Footer v-if="!isMobile" style="margin-top: 3rem"></Footer>
  </div>
</template>

<script>
// import axios from 'axios'
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";
// import {baseUrl} from '../../assets/js/public.js'

import Pagination from "@/components/pagination.vue";

export default {
  data() {
    return {
      sidedata: null,
      cidslist: [],
      isall: false,
      filtershow: true,

      data: null,
      page: 1,
      perPage: 6,

      sidebox: false,
      isMobile: false,
      searchkeyword: "",
      website: "",

      islogin: false,
      //   isuserlevel: false,
      //   默认全部都是会员
      isuserlevel: true,
    };
  },
  props: {},
  components: {
    Header,
    Footer,
    Pagination,
  },
  methods: {
    closetag(item) {
      for (let i in this.cidslist) {
        if (this.cidslist[i].id == item.id) {
          this.cidslist.splice(i, 1);
        }
      }
      this.getdata();
    },
    changewebsite() {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        this.website ? (this.website = "") : (this.website = 1);
        window.scrollTo(0, 0);
        this.getdata();
      }
    },
    tosearchmain(type) {
      this.$router.push({
        name: "searchmain",
        query: { type: type, keyword: this.searchkeyword },
      });
    },
    // 分页
    onPage(pageNow) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        // console.log('pageNow', pageNow);
        this.page = pageNow;
        window.scrollTo(0, 0);
        this.getdata();
      }
    },
    tosupplierdetail(item) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        this.$router.push({ name: "supplierdetail", query: { id: item.id } });
      }
    },
    checksidedata(item) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        if (this.cidslist.includes(item)) {
          for (let i in this.cidslist) {
            if (this.cidslist[i].id == item.id) {
              this.cidslist.splice(i, 1);
            }
          }
        } else {
          this.cidslist.push(item);
        }
        console.info("cidslist", this.cidslist);
        window.scrollTo(0, 0);
        this.getdata();
      }
    },
    checkall() {
      if (!this.isall) {
        this.cidslist = this.sidedata;
        this.isall = true;
      } else {
        this.cidslist = [];
        this.isall = false;
      }
      this.getdata();
    },
    changefollow(item) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        let params = {
          providerId: item.id,
        };
        this.request({
          method: "post",
          url: "/gci/user/provider/follow",
          data: params,
        })
          .then((res) => {
            this.getdata();
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
    },
    getdata() {
      let cids = "";
      for (let i in this.cidslist) {
        cids += this.cidslist[i].id + ",";
      }
      cids = cids.slice(0, -1);
      // console.info(cids)
      this.request({
        method: "get",
        url:
          "/gci/user/provider/list?cids=" +
          cids +
          "&page=" +
          this.page +
          "&perPage=" +
          this.perPage +
          "&haveWebsite=" +
          this.website,
      })
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getsidedata() {
      this.request({
        method: "get",
        url: "/gci/certification",
      })
        .then((res) => {
          this.sidedata = res.data;
          this.$bus.$emit("loading", false);
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
  },
  created() {
    this.$bus.$emit("loading", true);
  },
  mounted() {
    localStorage.getItem("isMobile") == "null"
      ? (this.isMobile = false)
      : (this.isMobile = true);
    if (localStorage.getItem("token")) {
      this.islogin = true;
      let userinfo = JSON.parse(localStorage.getItem("user"));
      if (userinfo.vip.id != 1) {
        this.isuserlevel = true;
      }
    }

    this.getsidedata();
    this.getdata();
  },
};
</script>

<style scoped lang="scss">
.main-img {
  min-width: 12rem;
  height: 12rem;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 0.2rem;
  margin-right: 1rem;
}
.r-title {
  height: 3rem;
  font-size: 1.5rem;
  font-weight: bold;
  position: relative;
  .r-title-bg {
    width: 13rem;
    position: absolute;
    left: -0.5rem;
    top: -2rem;
  }
}
.side-box {
  background-color: #fff;
  border-radius: 1rem;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  padding: 0;
  height: 100%;

  .side-title {
    color: #000;
    padding: 1rem;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
  }
  .side-content {
    display: flex;
    flex-direction: column;
    // padding: 1rem;
  }
}
.side-content::-webkit-scrollbar {
  display: none;
}
.main-box {
  display: flex;
  flex-direction: column;
  padding-left: 2rem;
}
.title-text {
  margin-left: -2rem;
}
.title-box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  color: #333;
  font-size: 3rem;
}
.title-icon {
  width: 3rem;
  height: 3rem;
  margin-top: 1rem;
}
.top-bg {
  width: 100vw;
  height: 20rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../assets/imgs/title-bg.jpg");
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  flex-direction: column;
}
.search-box {
  width: 30rem;
  height: 3rem;
  background-color: #fff;
  margin-top: 1rem;
  border-radius: 5rem;
  padding: 0 1rem;
  display: flex;
  align-items: center;
}
.main-title {
  color: #000;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.supplier-desc {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media (max-width: 767px) {
  .side-box {
    position: fixed;
    left: 0;
    top: 5rem;
    z-index: 9;
    height: 100%;
    border-radius: 0;
    padding-top: 5rem;
  }
  .top-bg {
    width: 100vw;
    height: 10rem;
    padding-top: 5rem !important;
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    .search-box {
      display: none;
    }
  }
  .main-box {
    margin-left: 4rem;
    min-width: calc(100vw - 4rem);
    padding: 0.5rem;
    margin-top: 10rem;
  }
  .main-img {
    min-width: 100%;
    height: 10rem;
    margin-bottom: 1rem;
    margin-right: 0;
  }
  .main-title {
    font-size: 1.2rem;
  }
  .supplier-box {
    flex-direction: column;
    padding: 0.5rem !important;
    margin-bottom: 1rem !important;
    justify-content: center;

    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.08);
  }
  .title-box {
    font-size: 2.2rem;
  }
  .title-icon {
    margin-top: 0.5rem;
  }
  .row {
    margin-top: 0 !important;
  }
}
</style>
